import { createFileRoute } from '@tanstack/react-router'
import { StatusScreen } from '@/components/ui/status-screen'
import errorSvg from '@/assets/error.svg'

export const Route = createFileRoute('/payment-status/failure')({
  component: FailurePage,
})

function FailurePage() {
  return (
    <StatusScreen
      image={errorSvg}
      alt="Error"
      title="Ошибка!"
      description="При обработке платежа произошла ошибка, повторите попытку."
      buttonContent="Вернуться на главную"
      linkProps={{ to: '/' }}
    />
  )
}
